/* eslint-disable no-console */

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`)
      .then(async reg => {
        console.log("[SW] Registered, scope:", reg.scope);
        await navigator.serviceWorker.ready;
        console.log("[SW] State: active");
      })
      .catch(err => {
        console.error("[SW] Registration failed:", err);
      });

    // Bridge: log all SW messages to the main page console
    navigator.serviceWorker.addEventListener("message", event => {
      console.log("[SW → Page] Message received:", event.data);
    });
  });
}
